'use client'

import './MainButton.scss'

import { feedbackFormModel } from '@/src/widgets/FeedbackForm/model'

export type IMainButton = {
  children: React.ReactNode
}

const MainButton = ({ children }: IMainButton) => {
  return (
    <div className="intro__form-info-button">
      <button onClick={feedbackFormModel.srollToMe}>{children}</button>
    </div>
  )
}

export default MainButton
